<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<div class="section level2" id="prologue">
<h1>Prologue</h1>
<p>In Baghdad, he was Mirin, after the Farsi for death sigh, <em>mirine mirin</em>.</p>
<p>He fled through a ventilation shaft in the bathroom stall of a vegetarian restaurant on Sadoon Street and into the night by the banks of the Tigris.</p>
<p>In Belgrade, he went by Bakar, meaning red or copper, after his russet hair. On that occasion, late ’93, he stole a fedora and sports jacket from the cloakroom and walked out of the bar into a waiting cab.</p>
<p>In Beirut, he had no name; referenced by a soft whistle and a gentle shake of the head. Just to speak of him was to invoke darkness. That day, an intense, sweaty chase through the souk at Al-Tawileh ended in a dead-end, soon filled with yelling stallholders.</p>
<p>In Belfast, his home town, he was Tam Croall. Or The Technician.</p>
<p>And that was just the Bs.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0005.vue?9b544180